<span>
  {{message}}
</span>

<button *ngIf="debugMode" mat-button color="accent" aria-label="Debug Connection" type="button" class="ml-24"
        (click)="onDebug()"
>
    Debug Connection
</button>


